import { h } from "preact";
import './Banner.scss';

interface Props {
  children: JSX.Element | string | any;
  className?: string;
  icon?: string;
  color?: "info" | "warning" | "error" | "success";
  background?: "info" | "warning" | "error" | "success";
}

export default function Banner({
  children,
  className = "",
  icon = "info-circle",
  color = "info",
  background = "info",
}: Props) {
  const textColor = color === "warning" ? "text-warning-900" : `text-${color}-600`;
  const iconColor = color === "warning" ? "text-warning-500" : `text-${color}-600`;

  return (
    <div
      className={`banner ${textColor} bg-${background}-50 border-${color}-600 flex gap-[20px] border-l-4 p-4 lg:p-8 shadow-sm ${className}`}
    >
      <i className={`fa fa-${icon} ${iconColor} text-[18px]`} />
      <p className={`${textColor} text-responsive`}>{children}</p>
    </div>
  );
}
